// src/App.js
import { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { toast, ToastContainer } from "react-toastify";

import BottomNav from './components/BottomNav';
import UserAccountPage from './pages/UserAccountPage';
import './styles/App.css';
import LoginPage from './components/auth_pages/Login';
import RegisterPage from './components/auth_pages/RegisterPage';
import ForgotPasswordPage from './components/auth_pages/ForgotPasswordPage';
import HomePage from './pages/HomePage';
import CreateSearchActivityPage from './pages/CreateSearchActivityPage';
import SearchActivityDetailPage from './pages/SearchActivityDetailPage';
import EditSearchActivityPage from './pages/EditSearchActivityPage';
import ChatPage from './pages/ChatPage';
import ChatsPage from './pages/ChatsPage';
import ProfileAfterLoginPage from './pages/ProfileAfterLoginPage';
import LandingPage from "./pages/LandingPage";
import DataPrivacyPage from "./pages/DataPrivacyPage";

// import { requestNotificationPermission } from "./services/firebaseNotification";
import { onMessage } from "firebase/messaging";
import { messaging } from "./services/firebase"; 
import Message from "./components/Message";

function AppContent() {
  const location = useLocation();

  // useEffect(() => {
  //   requestNotificationPermission();
  // }, []);

  useEffect(() => {
    onMessage(messaging, (payload) => {
      toast(<Message notification={payload.notification} />);
    });
  }, []);

  const hideBottomNavRoutes = ["/", "/data-privacy", '/auth/login', '/auth/register', '/auth/forgot-password', '/firstprofile'];
  const showBottomNav = !hideBottomNavRoutes.includes(location.pathname);

  const isLandingPage = location.pathname === "/";

  return (
    <>
      {isLandingPage ? (
        // Render LandingPage outside of app-container
        <Routes>
          <Route path="/" element={<LandingPage />} />
        </Routes>
      ) : (
        // All other pages inside app-container
        <div className="app-container">
          <div className="page-content">
            <Routes>
              <Route path="/auth/login" element={<LoginPage />} />
              <Route path="/auth/register" element={<RegisterPage />} />
              <Route path="/auth/forgot-password" element={<ForgotPasswordPage />} />
              <Route path="/home" element={<HomePage />} />
              <Route path="/create_search" element={<CreateSearchActivityPage />} />
              <Route path="/search_detail/:searchId" element={<SearchActivityDetailPage />} />
              <Route path="/edit-search/:searchId" element={<EditSearchActivityPage />} />
              <Route path="/chat/:groupId" element={<ChatPage />} />
              <Route path="/chats" element={<ChatsPage />} />
              <Route path="/useraccount" element={<UserAccountPage />} />
              <Route path="/firstprofile" element={<ProfileAfterLoginPage />} />
              <Route path="/data-privacy" element={<DataPrivacyPage />} />
            </Routes>
          </div>
          {showBottomNav && <BottomNav />}
        </div>
      )}
      <ToastContainer />
    </>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;